import React from 'react'
import ComponentSpacing from '../../../containers/ComponentSpacing'
import { ReactComponent as Icon } from '../../../../assets/icons/calculate.svg'
import { IconButton } from './../../Button'

export const CalculateButton = ({ onClick }) => (
  <IconButton onClick={onClick} Icon={Icon} />
)
